/* import __COLOCATED_TEMPLATE__ from './header.hbs'; */
import { PRESCREENER_CATEGORY_ROUTES } from 'client-portal/utils/prescreener/constants';
import { action, computed } from '@ember/object';
import { classNames } from '@ember-decorators/component';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
@classNames('header')
export default class RequestRequestWrapperHeader extends Component {
  @service session;
  @service request;
  @service prescreener;

  @computed('prescreener.preview.isPreview')
  get isPrescreenerPreview() {
    return this.prescreener.preview.isPreview;
  }

  @computed('isPrescreenerPreview', 'previousStep')
  get isPreviousStepDisabled() {
    let { isPrescreenerPreview, previousStep } = this;
    if (isPrescreenerPreview) {
      if (!previousStep) return true;

      const previousStepRoute = previousStep.route;

      return !PRESCREENER_CATEGORY_ROUTES.includes(previousStepRoute);
    }
    return false;
  }

  @action
  handlePreviousStepClick(event) {
    if (this.isPreviousStepDisabled) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  @computed('activeSteps', 'currentStep.title')
  get eventTrackingProperties() {
    let title = this.currentStep?.title;
    let props = {};
    if (title) {
      props = {
        'page_name': title,
        'page_number': this.activeSteps.findIndex(step => step.title === title) + 1,
        'client_type': this.request.findClientType(this.session.currentClient),
        'offers_free_service': this.request.hasFreeServices,
      };
    }
    return props;
  }
}
